module.exports = __webpack_public_path__ + "img/1481244590.51a937cb.jpg";